// extracted by mini-css-extract-plugin
export default {"mediaSelector":"mediaSelector__mediaSelector__ji_r6","close":"mediaSelector__close__bbeZn"};